import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlogService } from '../blogs/blog.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-blogs-read',
    templateUrl: './blogs-read.component.html',
    styleUrls: ['./blogs-read.component.css'],
    standalone: false
})
export class BlogsReadComponent implements OnInit {

  blog: any = null;
  loading = false;
  safeDescription: SafeHtml = '';

  commentForm!: FormGroup;

comments: any[] = [];

submittingComment = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blogService: BlogService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {

    this.commentForm = this.fb.group({
  name: ['', Validators.required],
  email: ['', [Validators.required, Validators.email]],
  phone: [''],
  comment: ['', Validators.required]
});

    this.route.paramMap.subscribe(params => {
      const param = params.get('slug'); // renamed from id → slug
      if (!param) return;

      // If numeric → old URL → redirect
      if (/^\d+$/.test(param)) {
        this.loadByIdAndRedirect(param);
      } else {
        this.loadBySlug(param);
      }
    });
  }

  // 🔁 OLD URL SUPPORT: /blogs/12 → /blogs/real-slug
  private loadByIdAndRedirect(id: string) {
    this.loading = true;
    this.blogService.getBlog(id).subscribe(
      res => {
        const blog = res.data || res;
        if (blog && blog.slug) {
          this.router.navigate(['/blogs', blog.slug], { replaceUrl: true });
        } else {
          this.assignBlog(blog);
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('Blog not found');
      }
    );
  }

  // ✅ NEW: Load by slug
  private loadBySlug(slug: string) {
    this.loading = true;
    this.blogService.getBlogBySlug(slug).subscribe(
      res => {
        const blog = res.data || res;
        this.assignBlog(blog);
        this.loading = false;
      },
      () => {
        this.loading = false;
        alert('Blog not found');
      }
    );
  }

  private assignBlog(blog: any) {
    if (!blog) return;
    this.blog = blog;
    this.safeDescription = blog.description
      ? this.sanitizer.bypassSecurityTrustHtml(blog.description)
      : '';

      this.loadComments();
  }

  loadComments() {

  this.blogService
    .getComments(this.blog.id)
    .subscribe({
      next: res => {
        this.comments = res.data || [];
      },
      error: err => {
        console.error(err);
      }
    });
}

submitComment() {

   console.log('SUBMIT CLICKED');

  if (this.commentForm.invalid) {
    this.commentForm.markAllAsTouched();
    return;
  }

  this.submittingComment = true;

  const payload = {
    blog_id: this.blog.id,
    name: this.commentForm.value.name,
    email: this.commentForm.value.email,
    phone: this.commentForm.value.phone,
    comment: this.commentForm.value.comment
  };

  this.blogService
    .addComment(payload)
    .subscribe({

      next: () => {

        alert(
          'Thank you. Your comment is awaiting approval.'
        );

        this.commentForm.reset();

        this.submittingComment = false;
      },

      error: () => {

        this.submittingComment = false;

        alert(
          'Failed to submit comment.'
        );
      }
    });
}
}